import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FlowFeedback } from '../../../../services/types/Flow';
import { dateTimeFormat } from '../../../../shared/misc/utils';

interface Props {
  feedbacks: FlowFeedback[] | null;
  title: string;
}

const FlowFeedbackTable: React.FC<Props> = (props) => {
  const { feedbacks, title } = props;
  const { t } = useTranslation();
  const renderRows = () => {
    if (!feedbacks) {
      return null;
    }
    return feedbacks.map((x, i) => (
      <tr key={`feedbackTable_tr${i.toString()}`}>
        <td>{x.user}</td>
        <td>{t(`flowIndications.${x.indicationCode}`)}</td>
        <td>{dateTimeFormat(x.date)}</td>
        <td>{x.comment || <span>Without comments</span>}</td>
      </tr>
    ));
  };

  return (
    feedbacks &&
    feedbacks.length > 0 && (
      <div className="flow-feedback-content">
        <p className="flow-feedback-title">{title}</p>
        <div className="history-content flow-history mb-0">
          <Table>
            <thead>
              <tr>
                <th>{t('member')}</th>
                <th>{t('indication')}</th>
                <th>{t('date')}</th>
                <th>{t('comments')}</th>
              </tr>
            </thead>
            <tbody>{renderRows()}</tbody>
          </Table>
        </div>
      </div>
    )
  );
};

export default FlowFeedbackTable;
